import styled from 'styled-components';
import CloseIcon from '../../../../Icons/CloseIcon';

export const TransactionVerifyMainWrap = styled.div(
    props => `
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: ${props.theme.spacing.large.l20}
    `
);

export const VerifyHeadWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
    `
);

export const VerifyTextWrap = styled.div(
    props => `
        width:80%;
        display: flex;
        flex-direction: column;
    `
);

export const VerifyPopHeadText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font18};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
    `
);

export const VerifyPopHeadSubText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.base};
    `
);

// export const VerifyPopMsg = styled.p(
//     props => `
//         font-size: ${props.theme.font.large.font12};
//         color: ${props.theme.colors.green.base};
//         padding-top: ${props.theme.spacing.small.s2};
//     `
// );

export const CloseIconWrap = styled(CloseIcon)(
    props => `
  
    color:${props.theme.colors.grey.grey75};
    cursor:pointer;
  
  `
);

export const VerifyOtpInfoWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding: ${props.theme.spacing.large.l15} 0;
    `
);

export const VerifyOtpBtnWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
    `
);

export const VerifyBtn = styled.button(
    props => `
        align-self: flex-end;
        display: flex;
        padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l25};
        border-radius: 34px;
        box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.2);
        background-image: linear-gradient(95deg, #53b2fe 1%, #065af3 130%);
        outline: none;
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.white.base};
        font-weight: ${props.theme.font.fontWeight.black};
        text-transform: uppercase;
        border: none;
        cursor: pointer;
    `
);

export const ErrorText = styled.span(
  props => `
        color: ${props.theme.colors.red.base};
        font-size: ${props.theme.font.large.font14};
        padding-top: ${props.theme.spacing.base};
        text-align: ${props.theme.font.textAlign.left};
        width: 100%;
        text-transform: ${props.theme.font.textTransform.capital};
    `,
);
